import React from 'react';
import { Box, Button } from '@mui/material';
import { ArrowOutward as ArrowOutwardIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const ExploreButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  borderRadius: '50px',
  padding: '10px 32px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  marginTop: '40px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '24px',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const ExploreNow = ({ onClick }) => (
  <Box textAlign="center">
    <ExploreButton
      endIcon={<ArrowOutwardIcon fontSize="small" />}
      onClick={onClick}
    >
      Explore Now
    </ExploreButton>
  </Box>
);

export default ExploreNow;
